const encode = ({ value }) => {
  if(!value)
    return null;

  return Buffer.from(value).toString('base64');
}

export default encode;
